import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const fetchTeachers = createAsyncThunk(
  "teachers/fetchTeachers",
  async (requestData) => {
    return await userService.fetchTeachers();
  }
);
